import { localeConfig } from 'shared/domains/languages/config';
import { getCurrentMarket } from 'shared/domains/markets/config';
// marketCode:localeCode
export const links = {
    homepage: {
        'uk:en-gb': '',
        'de:en-gb': '',
        'se:sv': 'sv',
        'se:sv-se': 'sv',
        'se:en-gb': '',
        'no:en-gb': '',
        'no:nb-no': '',
    },
    about: {
        'uk:en-gb': 'clm',
        'de:en-gb': 'clm',
        'se:sv': 'sv/clm',
        'se:sv-se': 'sv/clm',
        'se:en-gb': 'clm',
        'no:en-gb': 'clm',
        'no:nb-no': 'clm',
    },
    extSharingTerms: {
        'uk:en-gb': 'terms-of-service',
        'de:en-gb': 'terms-of-service',
        'se:sv': 'sv/anvandarvillkor',
        'se:sv-se': 'sv/anvandarvillkor',
        'se:en-gb': 'terms-of-service',
        'no:en-gb': 'terms-of-service',
        'no:nb-no': 'terms-of-service',
    },
    extSharingPrivacy: {
        'uk:en-gb': 'privacy-policy',
        'de:en-gb': 'privacy-policy',
        'se:sv': 'sv/integritetspolicy',
        'se:sv-se': 'sv/integritetspolicy',
        'se:en-gb': 'privacy-policy',
        'no:en-gb': 'privacy-policy',
        'no:nb-no': 'privacy-policy',
    },
};
export const appLinks = {
    signup: {
        'uk:en-gb': 'uk/signup',
        'de:en-gb': 'uk/signup',
        'se:sv': 'se/signup',
        'se:sv-se': 'se/signup',
        'se:en-gb': 'se/signup',
        'no:en-gb': 'no/signup',
        'no:nb-no': 'no/signup',
    },
};
export const externalLinks = {
    terms: {
        'uk:en-gb': 'https://miramis.co/terms',
        'de:en-gb': 'https://miramis.co/terms',
        'se:sv': 'https://miramis.co/terms',
        'se:sv-se': 'https://miramis.co/terms',
        'se:en-gb': 'https://miramis.co/terms',
        'no:en-gb': 'https://miramis.co/terms',
        'no:nb-no': 'https://miramis.co/terms',
    },
    dataProcessingAgreement: {
        'uk:en-gb': 'https://miramis.co/terms-of-service',
        'de:en-gb': 'https://miramis.co/terms-of-service',
        'se:sv': 'https://miramis.co/terms-of-service',
        'se:sv-se': 'https://miramis.co/terms-of-service',
        'se:en-gb': 'https://miramis.co/terms-of-service',
        'no:en-gb': 'https://miramis.co/terms-of-service',
        'no:nb-no': 'https://miramis.co/terms-of-service',
    },
    contact: {
        'uk:en-gb': 'https://miramis.co/support-tickets',
        'de:en-gb': 'https://miramis.co/support-tickets',
        'se:sv': 'https://miramis.co/support-tickets',
        'se:sv-se': 'https://miramis.co/support-tickets',
        'se:en-gb': 'https://miramis.co/support-tickets',
        'no:en-gb': 'https://miramis.co/support-tickets',
        'no:nb-no': 'https://miramis.co/support-tickets',
    },
    sales: {
        'uk:en-gb': 'https://miramis.co/contact-sales',
        'de:en-gb': 'https://miramis.co/contact-sales',
        'se:sv': 'https://miramis.co/contact-sales',
        'se:sv-se': 'https://miramis.co/contact-sales',
        'se:en-gb': 'https://miramis.co/contact-sales',
        'no:en-gb': 'https://miramis.co/contact-sales',
        'no:nb-no': 'https://miramis.co/contact-sales',
    },
    privacy: {
        'uk:en-gb': 'https://miramis.co/privacy-policy',
        'de:en-gb': 'https://miramis.co/privacy-policy',
        'se:sv': 'https://miramis.co/privacy-policy',
        'se:sv-se': 'https://miramis.co/privacy-policy',
        'se:en-gb': 'https://miramis.co/privacy-policy',
        'no:en-gb': 'https://miramis.co/privacy-policy',
        'no:nb-no': 'https://miramis.co/privacy-policy',
    },
    acceptableUsePolicy: {
        'uk:en-gb': 'https://miramis.co/acceptable-use-policy',
        'de:en-gb': 'https://miramis.co/acceptable-use-policy',
        'se:sv': 'https://miramis.co/acceptable-use-policy',
        'se:sv-se': 'https://miramis.co/acceptable-use-policy',
        'se:en-gb': 'https://miramis.co/acceptable-use-policy',
        'no:en-gb': 'https://miramis.co/acceptable-use-policy',
        'no:nb-no': 'https://miramis.co/acceptable-use-policy',
    },
    pricing: {
        'uk:en-gb': 'https://miramis.co/pricing',
        'de:en-gb': 'https://miramis.co/pricing',
        'se:sv': 'https://miramis.co/pricing',
        'se:sv-se': 'https://miramis.co/pricing',
        'se:en-gb': 'https://miramis.co/pricing',
        'no:en-gb': 'https://miramis.co/pricing',
        'no:nb-no': 'https://miramis.co/pricing',
    },
    eSigning: {
        'uk:en-gb': 'https://miramis.co/electronic-signature-software',
        'de:en-gb': 'https://miramis.co/electronic-signature-software',
        'se:sv': 'https://miramis.co/electronic-signature-software',
        'se:sv-se': 'https://miramis.co/electronic-signature-software',
        'se:en-gb': 'https://miramis.co/electronic-signature-software',
        'no:en-gb': 'https://miramis.co/electronic-signature-software',
        'no:nb-no': 'https://miramis.co/electronic-signature-software',
    },
};
function getMarket(localeCode, marketCode) {
    if (marketCode) {
        return marketCode;
    }
    switch (localeCode) {
        case 'sv':
        case 'sv-se':
            return 'se';
        case 'nb-no':
            return 'no';
        case 'en-gb':
        default:
            return 'uk';
    }
}
export function useGetLinks() {
    const localeCode = localeConfig.getActiveLocale().code;
    const marketCode = getCurrentMarket().code;
    const linkObject = {};
    Object.entries(links).forEach((link) => {
        const marketLocaleKey = `${getMarket(localeCode, marketCode)}:${localeCode}`;
        const [key, value] = link;
        const url = value[marketLocaleKey];
        linkObject[key] = `${process.env.WEBSITE_URL}/${url}`;
    });
    Object.entries(appLinks).forEach((link) => {
        const marketLocaleKey = `${getMarket(localeCode, marketCode)}:${localeCode}`;
        const [key, value] = link;
        const url = value[marketLocaleKey];
        linkObject[key] = `${process.env.APP_URL}/${url}`;
    });
    Object.entries(externalLinks).forEach((link) => {
        const marketLocaleKey = `${getMarket(localeCode, marketCode)}:${localeCode}`;
        const [key, value] = link;
        linkObject[key] = value[marketLocaleKey];
    });
    return linkObject;
}
